export default __webpack_public_path__ + "static/media/2.d2ae68f6.jpg";